import { render, staticRenderFns } from "./device_thirty_ratio.vue?vue&type=template&id=508f9c59&scoped=true&"
import script from "./device_thirty_ratio.vue?vue&type=script&lang=js&"
export * from "./device_thirty_ratio.vue?vue&type=script&lang=js&"
import style0 from "./device_thirty_ratio.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./device_thirty_ratio.vue?vue&type=style&index=1&id=508f9c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f9c59",
  null
  
)

export default component.exports